import Trans from 'next-translate/Trans'
import Image from 'next/image'

const DefaultSignUpCopy = () => (
  <div className='container-small'>
    <div className='pt-24 flex flex-col'>
      <header className='mb-10'>
        <h1 className='text-5xl font-medium'>
          <Trans i18nKey='common:user_signup_header' />
        </h1>
        <Trans
          i18nKey='common:user_signup_subheader'
          components={[
            <p className='text-3xl font-normal mt-8' />,
            <ul className='mt-4 font-thin text-md' />,
            <li className='list-disc mt-1' />,
          ]}
        />
      </header>
      <div className='w-4/5 mx-auto md:mt-32'>
        <div className='brain'>
          <Image
            src='/brain.png'
            width={450}
            height={340}
            priority
            alt='Bulldogjob - big brain'
          />
        </div>
        <div className='relative -top-6'>
          <Image
            src='/shadow.png'
            width={450}
            height={150}
            alt='Shadow of a big brain :/'
          />
        </div>
      </div>
    </div>
  </div>
)

export default DefaultSignUpCopy
